const ACCESS_TOKEN_KEY = "barreca.web.app.access.token";
const WEB_ID_TOKEN_KEY = "barreca.web.app.web.id.token";
const REFRESH_TOKEN_KEY = "barreca.web.app.refresh.token";
const EXPIRES_AT_TOKEN = "barreca.web.app.expires.at";
class AuthClientStore {
    static getAccessToken() {
        return localStorage.getItem(ACCESS_TOKEN_KEY);
    }

    static setAccessToken(token: string) {
        localStorage.setItem(ACCESS_TOKEN_KEY, token);
    }

    static setExpiresAt(token: string) {
        localStorage.setItem(EXPIRES_AT_TOKEN, token);
    }

    static getExpiresAt() {
        return localStorage.getItem(EXPIRES_AT_TOKEN);
    }

    static removeAccessToken(): void {
        localStorage.removeItem(ACCESS_TOKEN_KEY);
    }

    static getRefreshToken() {
        return localStorage.getItem(REFRESH_TOKEN_KEY);
    }

    static setRefreshToken(token: string) {
        localStorage.setItem(REFRESH_TOKEN_KEY, token);
    }

    static removeRefreshToken(): void {
        localStorage.removeItem(REFRESH_TOKEN_KEY);
    }

    static setWebUniqueId(token: string) {
        localStorage.setItem(WEB_ID_TOKEN_KEY, token);
    }

    static getWebUniqueId() {
        return localStorage.getItem(WEB_ID_TOKEN_KEY);
    }

    static removeWebUniqueId(): void {
        localStorage.removeItem(WEB_ID_TOKEN_KEY);
    }
}

export default AuthClientStore;